import styled, { css } from 'styled-components';

export const ListContainer = styled.div<{
  direction: 'row' | 'column';
  gap?: number;
  columnGap?: number;
  columns?: number;
  rows?: number;
}>`
  display: flex;
  gap: ${({ gap }) => (gap ? `${gap}px` : '0')};

  ${({ direction }) => {
    if (direction === 'row') {
      return css`
        flex-direction: row;
        flex-wrap: wrap;
      `;
    }

    if (direction === 'column') {
      return css`
        flex-direction: column;
      `;
    }

    return '';
  }}

  ${({ columns, rows, columnGap }) => {
    if (columns && columns > 1) {
      return css`
        display: grid;
        grid-template-columns: repeat(${columns}, 1fr);
        ${
          columnGap
            ? css`
                column-gap: ${columnGap}px;
              `
            : ''
        }
        ${
          rows
            ? css`
                grid-template-rows: repeat(${rows}, auto);
                grid-auto-flow: column;
              `
            : ''
        }
      `;
    }

    return css``;
  }}
`;
